export const energyKpiData = {
    data: {
        cost:              3.27,
        costChange:        .126,
        consumption:       139.54,
        consumptionChange: .0872,
        carbon:            13.61,
        carbonChange:      .1648
    }
};
